import { Card, message, Button, Space } from 'antd';
import Clipboard, { Event } from 'clipboard';
import { observer } from 'mobx-react';
import React, { useState, useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import holderImg from '@/assets/images/public/no-permission.svg';
import { userImplement } from '@/config/hooks/user';
import { getParamFromUrl } from '@/infrastructure/history';
import { useStores } from '@/presentation/store';
import { FreeStatus } from '@/service/pro-user';
import { ProductType } from '@/service/product-permissions';
import { SendPermission } from './dialog/send-permission';
import { SubmitResult } from './dialog/submit-result';
import style from './index.module.scss';

export const InternalPermission = observer(() => {
  const productId = getParamFromUrl('productId');
  const { productType, product } = useStores().ProductStore;
  const [permissionDialogVisible, setPermissionDialogVisible] = useState(false);
  const [submitDialogVisible, setSubmitDialogVisible] = useState(false);
  const [submitResult, setIsSubmitResult] = useState('succ');
  const [clipboard, setClipboard] = useState<ClipboardJS>();
  const linkParams = new URLSearchParams();

  const isExpiredProduct = productType === ProductType.FREE_PRODUCT && product.freeStatus === FreeStatus.Expired;

  useEffect(() => {
    setClipboard(new Clipboard('#copyBtn'));
    return () => {
      clipboard?.destroy();
    };
  }, []);

  const showCopyMessage = () => {
    clipboard?.on('success', () => {
      message.destroy();
      message.success('复制成功');
    });
    clipboard?.on('error', (e: Event) => {
      message.destroy();
      message.error('复制失败');
      console.log('复制失败==>', e.trigger, e.action);
    });
  };

  const renderNoticeText = () => {
    // 如果确实没权限
    console.log('renderNoticeText', productType, product);
    if (productType === ProductType.FREE_PRODUCT && product.freeStatus === FreeStatus.Expired) {
      return <p> 尊敬的用户，当前体验产品已过期。如需在专业版继续查看数据，请<Link
        to={{ pathname: '/resource-pack', search: linkParams.toString() }}
        target="_blank"
      >升级为付费产品。</Link>。</p>;
    }

    return (
      <Fragment>
        <p> 尊敬的用户，你没有访问当前产品的权限，请联系相关产品的管理员将你添加到项目成员中，或者联系Bugly小助手。</p>
        <p>（你的用户 ID为：{userImplement.getUserId()}，详情请点击右上角头像，查看个人信息。）</p>
      </Fragment>
    );
  };

  return <Card bordered={false} style={{ flex: 1, background: '#f0f2f5' }}>
    <div className={style.holder}>
      <img src={holderImg} alt={''} />
      <h4 className={style.subtitle}>温馨提示</h4>
      <div className={style.subDesc}>
        {renderNoticeText()}
      </div>
      {!isExpiredProduct && <Space>
        <Button style={{ border: 'none', background: '#EBEFF5' }} onClick={() => location.reload()}>刷新</Button>
        {productId && <Button onClick={() => setPermissionDialogVisible(true)} type={'primary'}>申请加入项目</Button>}
      </Space>}
    </div>
    <SendPermission
      permissionDialogVisible={permissionDialogVisible}
      setPermissionDialogVisible={setPermissionDialogVisible}
      setIsSubmitResult={setIsSubmitResult}
      setSubmitDialogVisible={setSubmitDialogVisible}
    />
    <SubmitResult
      showCopyMessage={showCopyMessage}
      submitResult={submitResult}
      submitDialogVisible={submitDialogVisible}
      setSubmitDialogVisible={setSubmitDialogVisible}
    />
  </Card>;
});
